import { IonContent, IonPage } from '@ionic/react';
import { useLocalStorage } from 'beautiful-react-hooks';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Pill from '../components/c-pill';

export default function Terms() {
	const [session, setSession] = useLocalStorage('session');
	const h = useHistory();

	const cancel = async (id) => {
		try {
			if (session) {
				const _session = JSON.parse(session);
				const { token, puid, srv } = _session;
				const action = 'finish';
				const base = srv === 'A' ? process.env.REACT_APP_API_A : process.env.REACT_APP_API_B;
				await axios.post(`${base}/${puid}/act`, { action }, { headers: { Authorization: `Bearer ${token}` } });
				h.push('/');
			}
		} catch (error) {
			console.log('error', error);
		}
	};

	const next = () => {
		h.push('/D');
	};

	return (
		<IonPage>
			<IonContent fullscreen scrollY={true}>
				<div className='w-full h-auto justify-items-center items-center flex flex-col px-7 bg-c-purple'>
					<img src={`/assets/media/tela-2-mobile-1.png`} className='mt-12' />
					<p className='font-bar text-center text-sm px-6 mt-6'>
						Este web app faz parte da exposição “Tempo de Reação – 100 anos do goleiro Barbosa”, do Museu do Futebol. A gravação em áudio a ser
						realizada a seguir, as opiniões nela expressas e a decisão de divulgá-las ou não, por quaisquer canais, são de inteira responsabilidade do
						usuário.
					</p>
					<h2 className='font-pro text-center text-xl px-6 mt-6 text-c-yellow'>POLÍTICA DE PRIVACIDADE</h2>
					<p className='font-bar text-center text-sm px-6 mt-2 '>
						Coletamos nome e e-mail do usuário deste web app especificamente para envio do áudio gravado na cabine Rádio Grande Área. Em nenhuma
						hipótese o Museu do Futebol disponibiliza estas informações a terceiros. Elas serão armazenadas em servidor local com segurança até
						21/02/2022 e em seguida apagadas, junto com os áudios. Caso o próprio usuário poste o áudio em suas redes sociais de maneira aberta, a
						instituição poderá compartilhá-lo nas redes sociais institucionais, para fins de divulgação da exposição. O Museu do Futebol poderá entrar
						em contato por e-mail oferecendo a possibilidade de cadastramento em nossa newsletter.
					</p>
					<Pill label={`aceito`} className={`mt-auto mb-7 w-[80vw] h-18 mt-10 bg-c-yellow text-c-purple`} onTap={next} />
				</div>
			</IonContent>
		</IonPage>
	);
}
